import { IAttrValue } from "@multiweb/types/contracts";
import { IAttrStringValue } from "./IAttrValue";

export class AttrValue implements IAttrValue {
    protected _value: any;

    constructor(value: any) {
        this._value = value;
    }

    public valueOf(): any {
        return this._value;
    }

    public toString(): string {
        return this._value != null ? this._value.toString() : "";
    }
}

/** Představuje řetězcovou hodnotu atributu aplikačního objektu. */
export class AttrStringValue extends AttrValue implements IAttrStringValue {
    public readonly shortened: boolean;

    constructor(value: any, shortened: boolean = false) {
        super(value);
        this.shortened = shortened;
    }

    public override toString(): string {
        return this._value != null ? this.shortened ? this._value.toString() + "..." : this._value.toString() : "";
    }
}
